import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative items-center py-4" }
const _hoisted_2 = { class: "flex justify-center align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    "is-displayed": _ctx.isMoveToNewCompanyModalOpened,
    "is-select-modal": true,
    "no-padding": true,
    "have-modal": _ctx.haveModal,
    title: "Move asset to other company",
    onToggleModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_form_wrapper, {
        "is-form-in-modal": true,
        "is-loading": _ctx.isLoading,
        "need-for-scroll": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_form_divider, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Companies", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.selectedCompanyId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCompanyId) = $event)),
                    class: _normalizeClass(`mt-1`),
                    options: _ctx.companies,
                    reduce: (spot) => spot.id,
                    label: "name"
                  }, _createSlots({ _: 2 }, [
                    (_ctx.hasNextPage)
                      ? {
                          name: "list-footer",
                          fn: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                              _createElementVNode("div", {
                                class: "mt-1 cursor-pointer bg-primary px-3 py-1 text-white transition duration-300 hover:bg-primaryhover disabled:cursor-not-allowed",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMoreCompanies && _ctx.loadMoreCompanies(...args)))
                              }, " Load more... ")
                            ])
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options", "reduce"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
          ], 32)
        ]),
        _: 1
      }, 8, ["is-loading"])
    ]),
    _: 1
  }, 8, ["is-displayed", "have-modal"]))
}